module.exports = __webpack_public_path__ + "img/six.724fffce.png";